export default __webpack_public_path__ + "static/media/NOD.6e56d16e.jpg";